"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _ClientOrderListSkeleton = _interopRequireDefault(require("../../Clients/ClientOrderListSkeleton"));
var _OrderCard = _interopRequireDefault(require("../OrderCard"));
var _constants = require("../OrderStatus/constants");
var _orderCardPropTypes;
var _excluded = ["isLoading", "orders", "visible", "attachable", "onClickOrderId", "detachable", "activeTicket", "onAttachTicket"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var OrderCardList = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var isLoading = _ref.isLoading,
    orders = _ref.orders,
    visible = _ref.visible,
    attachable = _ref.attachable,
    onClickOrderId = _ref.onClickOrderId,
    detachable = _ref.detachable,
    activeTicket = _ref.activeTicket,
    onAttachTicket = _ref.onAttachTicket,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isExpand = _useState2[0],
    setIsExpand = _useState2[1];
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(StyledListSkeleton, null);
  }
  if ((0, _isEmpty2["default"])(orders)) {
    return null;
  }
  var headline = "\u0417\u0430\u043A\u0430\u0437\u044B \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \xB7 ".concat(orders.length);
  var hasHidden = orders.length > visible;
  var shownOrders = isExpand ? orders : orders.slice(0, visible);
  return /*#__PURE__*/_react["default"].createElement(StyledOrderCardList, props, /*#__PURE__*/_react["default"].createElement(StyledHeadline, null, headline), /*#__PURE__*/_react["default"].createElement(StyledList, null, shownOrders.map(function (order) {
    return /*#__PURE__*/_react["default"].createElement(StyledOrderCard, (0, _extends2["default"])({
      key: order.id,
      onClickOrderId: onClickOrderId,
      activeTicket: activeTicket,
      attachable: attachable,
      detachable: detachable,
      onAttachTicket: onAttachTicket
    }, order));
  })), !isExpand && hasHidden && /*#__PURE__*/_react["default"].createElement(StyledShowMoreButton, {
    functional: true,
    onClick: setIsExpand
  }, "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0435 \u0437\u0430\u043A\u0430\u0437\u044B"));
});
OrderCardList.displayName = 'OrderCardList';

// старые типы из OrderCard (TODO: убрать при переносе на ts)
var orderCardPropTypes = (_orderCardPropTypes = {
  // старые типы из компонента OrderStatus (OrderStatusPropTypes)
  // TODO: убрать при переносе на ts
  className: _propTypes["default"].string,
  href: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  status: _propTypes["default"].oneOf(Object.values(_constants.ORDER_STATUSES)).isRequired,
  onClickId: _propTypes["default"].func,
  suffix: _propTypes["default"].node,
  attachable: _propTypes["default"].bool,
  detachable: _propTypes["default"].bool
}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_orderCardPropTypes, "className", _propTypes["default"].string), "countryCode", _propTypes["default"].string), "details", _propTypes["default"].string), "hotelName", _propTypes["default"].string.isRequired), "onAttachTicket", _propTypes["default"].func), "onCreateTicket", _propTypes["default"].func), "onClickOrderId", _propTypes["default"].func), "region", _propTypes["default"].string), "segment", _propTypes["default"].string), "ticketable", _propTypes["default"].bool), (0, _defineProperty2["default"])(_orderCardPropTypes, "activeTicket", _propTypes["default"].shape({
  id: _propTypes["default"].string
})));
OrderCardList.propTypes = {
  className: _propTypes["default"].string,
  isLoading: _propTypes["default"].bool,
  orders: _propTypes["default"].arrayOf(_propTypes["default"].shape(orderCardPropTypes).isRequired).isRequired,
  visible: _propTypes["default"].number,
  attachable: _propTypes["default"].bool,
  detachable: _propTypes["default"].bool,
  onAttachTicket: _propTypes["default"].func,
  onClickOrderId: _propTypes["default"].func,
  activeTicket: _propTypes["default"].shape({
    id: _propTypes["default"].string
  })
};
OrderCardList.defaultProps = {
  className: '',
  isLoading: true,
  visible: 5,
  attachable: false,
  detachable: false,
  onAttachTicket: Function.prototype,
  onClickOrderId: Function.prototype,
  activeTicket: null
};
var StyledOrderCardList = _styledComponents["default"].div.withConfig({
  displayName: "OrderCardList__StyledOrderCardList",
  componentId: "sc-1d36pfg-0"
})(["display:flex;flex-direction:column;"]);
var StyledOrderCard = (0, _styledComponents["default"])(_OrderCard["default"]).withConfig({
  displayName: "OrderCardList__StyledOrderCard",
  componentId: "sc-1d36pfg-1"
})(["padding:10px;"]);
var StyledHeadline = _styledComponents["default"].div.withConfig({
  displayName: "OrderCardList__StyledHeadline",
  componentId: "sc-1d36pfg-2"
})(["color:#919499;flex-shrink:0;font-size:12px;height:23px;line-height:23px;padding:0 10px;"]);
var StyledList = _styledComponents["default"].div.withConfig({
  displayName: "OrderCardList__StyledList",
  componentId: "sc-1d36pfg-3"
})(["flex-grow:1;"]);
var StyledListSkeleton = (0, _styledComponents["default"])(_ClientOrderListSkeleton["default"]).withConfig({
  displayName: "OrderCardList__StyledListSkeleton",
  componentId: "sc-1d36pfg-4"
})(["padding:7px 10px;"]);
var StyledShowMoreButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "OrderCardList__StyledShowMoreButton",
  componentId: "sc-1d36pfg-5"
})(["color:#007aff;font-size:12px;padding:0 10px;text-align:left;"]);
OrderCardList.STATUSES = _constants.ORDER_STATUSES;
var _default = exports["default"] = OrderCardList;